import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Error404() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-brand-navy-50 px-4">
      <SEO
        title="404 Siden blev ikke fundet | Jan Nørgaard"
        description="Siden du leder efter findes ikke hos Entreprenør Jan Nørgaard ApS. Gå til forsiden eller se vores referencer."
        noindex={true}
      />
      <div className="text-center max-w-md">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-brand-orange-100 text-brand-orange-600 mb-6">
          <i className="fa-duotone fa-compass-slash text-4xl" />
        </div>
        <h1 className="font-display text-4xl font-bold uppercase text-brand-navy-900 tracking-tight">
          404 Side Ikke Fundet
        </h1>
        <p className="mt-4 text-brand-navy-600 leading-relaxed">
          Beklager, men den side du leder efter, findes ikke eller er blevet flyttet. Brug menuen ovenfor eller klik herunder for at komme tilbage.
        </p>
        <div className="mt-8 flex justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded bg-brand-orange-500 px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-brand-orange-600"
          >
            <i className="fa-solid fa-house" /> Gå til forsiden
          </Link>
          <Link
            to="/referencer"
            className="inline-flex items-center gap-2 rounded border border-brand-navy-200 bg-white px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-brand-navy-900 transition-colors hover:bg-brand-navy-100"
          >
            Se vores referencer
          </Link>
        </div>
      </div>
    </div>
  );
}
